import axios, { AxiosInstance } from 'axios';
import { toast } from 'react-toastify';

export let axiosInstance: AxiosInstance | null = null;
let isAuth : boolean = false;

/**
 * Gets or creates a axiosInstance
 * 
 * @param forceRecreation permits the force recreation of the singleton
 * @returns void | Error<any> 
 */
export const getAxiosInstance = (forceRecreation?: boolean) : AxiosInstance => {
  if(!axiosInstance || !isAuth || forceRecreation) {
    const token = localStorage.getItem("token");

    let baseURL = process.env.REACT_APP_BACKEND_URL;
    if (process.env.REACT_APP_DEBUG === "true") {
      baseURL = "/api";
    }

    axiosInstance = axios.create({
      baseURL: baseURL,
      headers:   {
        Authorization: `Bearer ${token}`
      },
    });

    axiosInstance.interceptors.response.use((response) => {
      return response;
    },
    (error) => {
      if (error.response.status === 403) {
        if(window) window.location.replace("/403");
        toast.error("Nu sunteți logat!", { position: "bottom-right" });
      } else if(error.response.status === 401) {
        if(window) window.location.replace("/401");
        toast.error("Nu aveți permisunile necesare!", { position: "bottom-right" });
      }

      return Promise.reject(error);
    });
    if(token) isAuth = true;
  }
  
  return axiosInstance;
}